import { Node, mergeAttributes } from '@tiptap/core';

export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-variable'),
        renderHTML: (attrs) => ({ 'data-variable': attrs.id }),
      },
    };
  },
  parseHTML() {
    return [{ tag: 'span[data-variable]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'cro-variable-chip' }),
      `$${HTMLAttributes['data-variable']}`,
    ];
  },
  renderText({ node }) {
    return `$${node.attrs.id}`;
  },
});

export const insertVariable = (editor, id) => {
  editor.chain().focus().insertContent({ type: 'variable', attrs: { id } }).run();
};
